import { Box, Img, Text,Button } from '@chakra-ui/react';
import React from 'react';
import bull from 'assets/img/screens/bullet.png';
import { jsPDF } from 'jspdf'; 
import { NotoSansTamil } from "assets/fonts/NotoSansTamil-Regular";
import {NotoSansHindi} from "assets/fonts/NotoSansDevanagari-Regular"
import download from 'assets/img/games/download.png';

import TkDesign from 'assets/img/games/Thankyou/takeawayDesign.webp';
import Scrollbar from 'components/customScroll/CustomScroll';
interface Badge {
  gasId: number;
  gasAssetImage: string;
  gasAssetName: string;
}

const TakewayScreen: React.FC<{
  formData: any;
  imageSrc: any;
  preview: any;
  preloadedAssets?: any;
}> = ({ formData, imageSrc, preview, preloadedAssets }) => {
  const data = formData.gameTakeawayContent?.split('\n');
console.log(data,'dataintakewaydesign')
  // const handleDownloadPDF = () => {
  //   if (!formData.gameTakeawayContent || formData.gameTakeawayContent.length === 0) return;

  //   const doc = new jsPDF();
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const marginLeft = 15;
  //   let y = 25;


  //    doc.addFileToVFS("NotoSansTamil-Regular.ttf", NotoSansTamil);
  //       doc.addFont("NotoSansTamil-Regular.ttf", "NotoSansTamil", "normal");
    
  //       doc.addFileToVFS("NotoSansDevanagari-Regular.ttf", NotoSansHindi);
  //       doc.addFont("NotoSansDevanagari-Regular.ttf", "NotoSansHindi", "normal");
    
  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(18);
  //   const title = "Game Takeaway Content";
  //   const titleWidth = doc.getTextWidth(title);
  //   const centerX = (pageWidth - titleWidth) / 2;
  //   doc.text(title, centerX, y);
  //   y += 15;

  //   // 📝 Body
  //   doc.setFont("helvetica", "normal");
  //   doc.setFontSize(12);

 
  //   data.forEach((line: string) => {
  //     const cleanLine = line.replace(/^\s*[\u2022•]\s*/, ""); 
  //     const wrappedText = doc.splitTextToSize(`• ${cleanLine}`, 180);


  //     if (y > 270) {
  //       doc.addPage();
  //       y = 25;
  //     }

  //     doc.text(wrappedText, marginLeft, y);
  //     y += wrappedText.length * 8;
  //   });


  //   doc.save("Takeaway_Content.pdf");
  // };


// const handleDownloadPDF = () => {
//   if (!formData.gameTakeawayContent || formData.gameTakeawayContent.length === 0) return;

//   const doc = new jsPDF();

//   // 🧠 Register NotoSans

//   // doc.addFileToVFS('NotoSans-Regular.ttf', notoSansRegular);
//   doc.addFont('NotoSans-Regular.ttf', 'NotoSans', 'normal');
//   doc.setFont('NotoSans'); // Use your embedded font

//   const pageWidth = doc.internal.pageSize.getWidth();
//   const marginLeft = 15;
//   let y = 25;

//   // 🎯 Title
//   doc.setFontSize(18);
//   const title = 'Game Takeaway Content';
//   const titleWidth = doc.getTextWidth(title);
//   const centerX = (pageWidth - titleWidth) / 2;
//   doc.text(title, centerX, y);
//   y += 15;

//   // 🧪 TEST: Multilingual text
//   doc.setFontSize(12);

//   doc.text("வணக்கம் (Tamil)", marginLeft, y); y += 15;
//   doc.text("English Text", marginLeft, y);
//   y += 10;
//   doc.text("नमस्ते (Hindi)", marginLeft, y);
//   y += 10;
//   doc.text("مرحبا (Arabic)", marginLeft, y);
//   y += 10;
//   doc.text("你好 (Chinese)", marginLeft, y);
//   y += 10;
//   doc.text("שלום (Hebrew)", marginLeft, y);
//   y += 15;

//   // ✅ Actual Content
//   data.forEach((line: string) => {
//     const cleanLine = line.replace(/^\s*[\u2022•]\s*/, ''); // remove extra bullets
//     const wrappedText = doc.splitTextToSize(`• ${cleanLine}`, 180);

//     if (y > 270) {
//       doc.addPage();
//       y = 25;
//     }

//     doc.text(wrappedText, marginLeft, y);
//     y += wrappedText.length * 8;
//   });

//   doc.save('Takeaway_Content.pdf');
// };



//   const handleDownloadPDF = () => {
//   if (!formData.gameTakeawayContent || formData.gameTakeawayContent.length === 0) return;

//   const doc = new jsPDF();

//   // 🧠 Register and set NotoSans font
//   doc.addFileToVFS('NotoSans-Regular.ttf', notoSansRegular);
//   doc.addFont('NotoSans-Regular.ttf', 'NotoSans', 'normal');
//   doc.setFont('NotoSans'); // ✅ Set it here

//   const pageWidth = doc.internal.pageSize.getWidth();
//   const marginLeft = 15;
//   let y = 25;

//   // 🎯 Title
//   doc.setFontSize(18);
//   const title = 'Game Takeaway Content';
//   const titleWidth = doc.getTextWidth(title);
//   const centerX = (pageWidth - titleWidth) / 2;
//   doc.text(title, centerX, y);
//   y += 15;

//   // 📝 Body content
//   doc.setFontSize(12);

//   data.forEach((line: string) => {
//     const cleanLine = line.replace(/^\s*[\u2022•]\s*/, ''); // remove extra bullets
//     const wrappedText = doc.splitTextToSize(`• ${cleanLine}`, 180);

//     if (y > 270) {
//       doc.addPage();
//       y = 25;
//     }

//     doc.text(wrappedText, marginLeft, y);
//     y += wrappedText.length * 8;
//   });

//   // 💾 Save the file
//   doc.save('Takeaway_Content.pdf');
// };


const handleDownloadPDF = () => {
  if (!formData.gameTakeawayContent || formData.gameTakeawayContent.length === 0) return;

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginLeft = 15;
  let y = 25;

  // Add Tamil and Hindi fonts
  doc.addFileToVFS("NotoSansTamil-Regular.ttf", NotoSansTamil);
  doc.addFont("NotoSansTamil-Regular.ttf", "NotoSansTamil", "normal");

  doc.addFileToVFS("NotoSansDevanagari-Regular.ttf", NotoSansHindi);
  doc.addFont("NotoSansDevanagari-Regular.ttf", "NotoSansHindi", "normal");

  // Title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  const title = "Game Takeaway Content";
  const titleWidth = doc.getTextWidth(title);
  const centerX = (pageWidth - titleWidth) / 2;
  doc.text(title, centerX, y);
  y += 15;

  // 📝 Body - Ensure that Tamil and Hindi content is rendered with the respective fonts
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);

  // Assuming data is an array of strings containing mixed languages
  data.forEach((line:any) => {
    let cleanLine = line.replace(/^\s*[\u2022•]\s*/, ""); // Clean line
    const wrappedText = doc.splitTextToSize(`• ${cleanLine}`, 180);

    // Check if line contains Tamil or Hindi and switch font
    if (containsTamil(cleanLine)) {
      doc.setFont("NotoSansTamil"); // Set Tamil font
    } else if (containsHindi(cleanLine)) {
      doc.setFont("NotoSansHindi"); // Set Hindi font
    } else {
      doc.setFont("helvetica", "normal"); // Default font (for English or other content)
    }

    if (y > 270) {
      doc.addPage();
      y = 25;
    }

    doc.text(wrappedText, marginLeft, y);
    y += wrappedText.length * 8; // Adjust this value as per your text's line height
  });

  doc.save("Takeaway_Content.pdf");
};

// Helper function to check if text contains Tamil characters
const containsTamil = (text:any) => /[ா-௺]/.test(text);

// Helper function to check if text contains Hindi characters
const containsHindi = (text:any) => /[अ-ह]/.test(text);

return (
    <>
      {imageSrc && (
        <>
          <Box
            w={'100%'}
            h={'100%'}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Box
              w={'auto'}
              h={'auto'}
              position={'relative'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <Img
                src={TkDesign}
                h={'auto'}
                w={'100%'}
                transition={'transform 0.3s ease'}
              />
              <Box
                position={'absolute'}
                transition={'transform 0.3s ease'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                flexDirection={'column'}
                w={'100%'}
                h={'55%'}
                top={{ base: '25.5%' }}
                fontFamily={'AtlantisText'}
              >
                <Box className="takeaway_content">
                  <Scrollbar>
                    {data &&
                      data.map((it: any, ind: number) => {
                        const bulletIndex = it.indexOf('\u2022');
                        const contentAfterBullet =
                          bulletIndex !== -1
                            ? it.slice(bulletIndex + 1).trim()
                            : it;
                        return (
                          <Box
                            display={'flex'}
                            alignItems={'flex-start'}
                            h={'auto'}
                          >
                            <Img
                              src={preloadedAssets?.bull ?? bull}
                              className="dot-img"
                              w={'16px'}
                              h={'16px'}
                            />
                            <Text
                              ml={'5px'}
                              fontSize={'1rem'}
                              color={'#D9C7A2'}
                              fontFamily={'AtlantisContent'}
                              overflowWrap={'anywhere'}
                              letterSpacing={'0.4px'}
                            >
                              {contentAfterBullet}
                            </Text>
                          </Box>
                        );
                      })}
                      
                  </Scrollbar>
                 
                </Box>
                {/* <Box
  position="absolute"
  bottom="-38%"
  right="11%"
  zIndex="10"
  className='download-mouse'
>
  <button 
  // onClick={handleDownloadPDF}
   className="download-btntakeaway">
    <Img
      src={download}
      alt="Download"
      w="100%"
      h={{ base: '20px', md: '75px' }} // 👈 Responsive height
    />
  </button>
</Box> */}
              </Box>
            </Box>
          </Box>
        </>
      )}
    </>
  );
};
export default TakewayScreen;
